import React from 'react';
import ReactDOM from 'react-dom';
import { PortadaApp } from './PortadaApp';
import './assets/style.css'
import './assets/main.css'
ReactDOM.render(
    <PortadaApp />,
  document.getElementById('root')
);